import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
    Container,
    Paper,
    Typography,
    Button,
    Box
} from '@mui/material';
import CancelIcon from '@mui/icons-material/Cancel';

const PaymentCancel = () => {
    const navigate = useNavigate();

    return (
        <Container maxWidth="sm" sx={{ mt: 4 }}>
            <Paper elevation={3} sx={{ p: 4, textAlign: 'center' }}>
                <CancelIcon sx={{ fontSize: 60, color: 'error.main', mb: 2 }} />
                <Typography variant="h5" gutterBottom>
                    Payment Cancelled
                </Typography>
                <Typography variant="body1" color="text.secondary" paragraph>
                    Your payment was cancelled. No charges were made.
                </Typography>
                <Box sx={{ mt: 3 }}>
                    <Button 
                        variant="contained" 
                        color="primary" 
                        onClick={() => navigate('/dashboard/contracts')}
                        sx={{ mr: 2 }}
                    >
                        Return to Contracts
                    </Button>
                </Box>
            </Paper>
        </Container>
    );
};

export default PaymentCancel;
